var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNextPage)?_c('nuxt-link',{ref:"link",staticClass:"btn-pill-outline-black m-4",class:{ 'pointer-events-none': _vm.loading },attrs:{"to":_vm.routeTo,"data-testid":"btn-product-grid-load-more"},on:{"click":_vm.observe}},[_vm._v(_vm._s(_vm.$t('collection.loadMore')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }